import { PhotoProvider, PhotoView } from "react-photo-view";
import { getDDMMYYYFormat, getHHmmFormat } from "../../../helper/dateTimeHelper";

export const GrantedArea = (props: { data: any[] }) => {
  const { data = [] } = props;

  return (
    <div className="d-flex" style={{ width: "200%", maxWidth: "120%" }}>
      {data.map((e) => (
        <div style={{ backgroundColor: e.color, color: "#FFFFFF", padding: "2px" }}>{e.label}</div>
      ))}
    </div>
  );
};

export const Photo = (props: { src: any }) => {
  const { src } = props;

  return src && (
    <PhotoProvider>
      <PhotoView src={src}>
        <img src={src} width={100} height={100} alt="" style={{ cursor: "pointer" }} />
      </PhotoView>
    </PhotoProvider>
  );
};

export const TripBusiness = (props: { data: any[] }) => {
  const { data } = props;

  return (
    <div className="d-flex flex-column">
      {data.map((item, index) => {
        return (
          <span key={index}>
            {`${item.from} - ${item.to} (${getDDMMYYYFormat(item.date)} ${getHHmmFormat(
              item.date
            )})`}
          </span>
        );
      })}
    </div>
  );
};
